import {spacer} from './spacer';

export const DEFAULT_BORDER_RADIUS = {
  br0: spacer(0),
  br05: spacer(2),
  br1: spacer(4),
  br2: spacer(8),
  br3: spacer(12),
  br4: spacer(16),
  br5: spacer(20),
  br6: spacer(24),
  br7: spacer(28),
  br8: spacer(32),
  br9: spacer(36),
  br10: spacer(40),
  br11: spacer(44),
  br12: spacer(48),
  input: '4px',
  button: '8px',
  checkbox: '3px',
  modal: '16px',
} as const;

export const createBorderRadius = () => DEFAULT_BORDER_RADIUS;
